// easyui-popup-menu.component.ts
// (c) 2017 EvoluS Srl
// (a) VG

import { Component, ElementRef, Input, ViewChild, AfterViewInit } from '@angular/core';

declare let $: any;

@Component({
  selector: 'easyui-popup-menu',
  template: `
    <div #host>
      <ng-content></ng-content>
    </div>
  `
})
export class EasyuiPopupMenuComponent implements AfterViewInit {
  private host: any;
  @Input('options') options: any;
  @Input('icon') icon: string;
  @ViewChild('host') hostElement: ElementRef;

  constructor() {}

  ngAfterViewInit() {
    this.configura(this.options);
  }

  public styleElement( tag: string, css: any) {
    const element = this.host.find(tag);
    element.css(css);
  }

  // metodi privati

  private configura(options: any) {
    this.host = $(this.hostElement.nativeElement);
    if (!options) { options = {}; }
    if (this.icon) { options.iconCls = this.icon; }
    this.host.menu(options);
  }
}



// WEBPACK FOOTER //
// ./src/app/easyui-ts/easyui-popup-menu.component.ts